var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',[_c('el-col',{staticStyle:{"margin-top":"20vh"},attrs:{"span":12,"offset":6}},[_c('el-card',[_c('el-empty',{attrs:{"description":"来到了一个不存在的地方哦"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.back()}}},[_vm._v("返回")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }